import { Action, Dispatch } from 'redux'
import { initBreadsAction } from 'reducks/bread/actions'

const initBreads = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initBreadsAction())
  }
}

export default initBreads
